// src/components/Footer.jsx
import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  TextField,
  InputAdornment,
  Button
} from '@mui/material';
import {
  FaFacebookF,
  FaLinkedinIn,
  FaEnvelope,
  FaChevronUp
} from 'react-icons/fa';
import { motion } from 'framer-motion';

export default function Footer() {
  return (
    <Box
      component={motion.footer}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      sx={{ bgcolor: '#2e003f', color: 'white', pt: 8, pb: 4, mt: 8 }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* About & Logo */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" fontWeight={700} gutterBottom>
              LEMDA (Pvt) Ltd
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, maxWidth: 300 }}>
              Building AI-powered web & mobile solutions for forward-thinking businesses worldwide.
            </Typography>
            <Box>
              <IconButton href="https://www.facebook.com/Lemda.webdevelopment" target="_blank" color="inherit">
                <FaFacebookF />
              </IconButton>
              <IconButton href="https://lk.linkedin.com/company/lemda-pvt-ltd" target="_blank" color="inherit">
                <FaLinkedinIn />
              </IconButton>
              <IconButton href="mailto:lemda.webdev@gmail.com" color="inherit">
                <FaEnvelope />
              </IconButton>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Company
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="/" color="inherit" underline="hover">
                Home
              </Link>
              <Link href="about" color="inherit" underline="hover">
                About Us
              </Link>
              <Link href="services" color="inherit" underline="hover">
                Services
              </Link>
              <Link href="projects" color="inherit" underline="hover">
                Projects
              </Link>
              <Link href="contact" color="inherit" underline="hover">
                Contact
              </Link>
            </Box>
          </Grid>

          {/* Resources */}
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Resources
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
             
              <Link href="career" color="inherit" underline="hover">
                Careers
              </Link>
              <Link href="#faq" color="inherit" underline="hover">
                FAQ
              </Link>
            
            </Box>
          </Grid>

          {/* Newsletter */}
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Newsletter
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, maxWidth: 350 }}>
              Subscribe to get our latest insights and AI innovations delivered to your inbox.
            </Typography>
            <Box component="form" noValidate autoComplete="off" sx={{ display: 'flex', gap: 1 }}>
              <TextField
                variant="filled"
                placeholder="Your email"
                size="small"
                InputProps={{
                  disableUnderline: true,
                  sx: { bgcolor: 'white', borderRadius: 1 },
                }}
              />
              <Button
                variant="contained"
                sx={{ bgcolor: '#E30613', textTransform: 'none' }}
                type="submit"
              >
                Subscribe
              </Button>
            </Box>
          </Grid>
        </Grid>

        {/* Back to Top */}
        <Box sx={{ textAlign: 'center', mt: 6 }}>
          <IconButton
            href="#top"
            sx={{
              bgcolor: 'rgba(255,255,255,0.1)',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
            }}
            size="large"
          >
            <FaChevronUp color="white" />
          </IconButton>
        </Box>

        <Typography variant="body2" align="center" sx={{ pt: 4 }}>
          &copy; {new Date().getFullYear()} Lemda (Pvt) Ltd. All Rights Reserved.
        </Typography>
      </Container>
    </Box>
  );
}
